"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const Button_1 = __importDefault(require("../../../common/js/atoms/Button"));
const LoadingSpinner_1 = __importDefault(require("../../../common/js/components/LoadingSpinner"));
const ScopeGuard_1 = __importDefault(require("../../../common/js/components/security/ScopeGuard"));
const AuthorizationScopes_1 = __importDefault(require("../../../common/js/enums/AuthorizationScopes"));
const ButtonVariant_1 = __importDefault(require("../../../common/js/enums/ButtonVariant"));
const Zupicons_1 = __importDefault(require("../../../common/js/enums/Zupicons"));
const translation_1 = require("../../../common/js/helper/translation");
const Paths_1 = require("../../constants/Paths");
const history_1 = require("../../helper/history");
const media_1 = require("../../helper/media");
const path_1 = require("../../helper/path");
const ShopwareContext_1 = __importDefault(require("../../stores/ShopwareContext"));
const ShopwareProducts_1 = __importDefault(require("../../stores/ShopwareProducts"));
const SoftwareDownloads_1 = __importDefault(require("../SoftwareDownloads"));
class SoftwareDetailPage extends react_1.default.Component {
    contextReactionDisposer;
    internalIsLoading = false;
    product;
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            internalIsLoading: mobx_1.observable,
            product: mobx_1.observable,
            isLoading: mobx_1.computed,
            productId: mobx_1.computed,
            backToOverviewPath: mobx_1.computed,
            productMedia: mobx_1.computed,
            customFields: mobx_1.computed,
            loadSoftware: mobx_1.action.bound,
        });
    }
    get isLoading() {
        return this.internalIsLoading || ShopwareContext_1.default.isLoading;
    }
    get productId() {
        return this.props.match.params.product ?? null;
    }
    get backToOverviewPath() {
        return (0, path_1.localePath)(Paths_1.PATH_SOFTWARE);
    }
    get productMedia() {
        if (!this.product) {
            return [];
        }
        const { cover, media } = this.product;
        if (!media) {
            return [];
        }
        return media
            .filter((productMedia) => productMedia.mediaId !== cover?.mediaId)
            .map((productMedia) => productMedia.media)
            .filter((item) => !!item);
    }
    get customFields() {
        return this.product?.translated?.customFields ?? null;
    }
    componentDidMount() {
        document.title = (0, translation_1.t)('software_subpage_title', { title: this.product?.translated?.name });
        this.contextReactionDisposer = (0, mobx_1.reaction)(() => [ShopwareContext_1.default.customFields?.massiveSoftwareCategory, this.productId], () => this.loadSoftware(), { fireImmediately: true });
    }
    componentDidUpdate() {
        document.title = (0, translation_1.t)('software_subpage_title', { title: this.product?.translated?.name });
    }
    componentWillUnmount() {
        this.contextReactionDisposer?.();
    }
    render() {
        const [productImage = this.product?.cover?.media] = this.productMedia;
        return (react_1.default.createElement("section", { className: "znd-shop-product-page" },
            react_1.default.createElement(react_router_dom_1.Link, { to: this.backToOverviewPath },
                react_1.default.createElement(Button_1.default, { className: "znd-shop-product-page__back-button", variant: ButtonVariant_1.default.text, iconLeft: Zupicons_1.default.arrowLeft, text: (0, translation_1.t)('product_page.back') })),
            this.isLoading || !this.product ? (react_1.default.createElement("div", { className: "d-flex justify-content-center" },
                react_1.default.createElement(LoadingSpinner_1.default, null))) : (react_1.default.createElement("div", { className: "znd-shop-product-page__content" },
                react_1.default.createElement("header", { className: "znd-shop-product-page__top" },
                    productImage ? (react_1.default.createElement("div", { className: "znd-shop-product-page__image-wrapper" },
                        react_1.default.createElement("img", { ...(0, media_1.imageSourceFromMedia)(productImage), alt: productImage.alt, className: "znd-shop-product-page__image" }))) : null,
                    react_1.default.createElement("section", { className: "znd-shop-product-page__info" },
                        !!this.customFields?.massiveSoftwareConfigurationDescription && (react_1.default.createElement("div", { className: (0, classnames_1.default)('znd-software-page__full-description', 't-body'), dangerouslySetInnerHTML: {
                                __html: this.customFields?.massiveSoftwareConfigurationDescription,
                            } })),
                        !!this.customFields?.massiveSoftwareConfigurationUrlReadMore ? (react_1.default.createElement(Button_1.default, { className: "znd-software-page__bottom-read-more", variant: ButtonVariant_1.default.text, text: (0, translation_1.t)('product.read_more'), iconRight: Zupicons_1.default.externalLink, onClick: () => {
                                window.open(this.customFields?.massiveSoftwareConfigurationUrlReadMore ?? undefined, '_blank');
                            } })) : null,
                        react_1.default.createElement("div", { className: "znd-software-page__buttons d-flex w-100 justify-content-end" },
                            react_1.default.createElement(ScopeGuard_1.default, { scopes: [AuthorizationScopes_1.default.LICENSE_READ] },
                                react_1.default.createElement(react_router_dom_1.Link, { to: (0, path_1.localePath)(Paths_1.PATH_ASSETS_SOFTWARE) },
                                    react_1.default.createElement(Button_1.default, { variant: ButtonVariant_1.default.secondary, text: (0, translation_1.t)('software.detail.check_own_licence') }))),
                            !this.product.extensions?.massiveComputedProduct?.notPurchasable ? (react_1.default.createElement(ScopeGuard_1.default, { scopes: [AuthorizationScopes_1.default.SHOP_READ] },
                                react_1.default.createElement(react_router_dom_1.Link, { className: "ml-2", to: (0, path_1.localePath)(Paths_1.PATH_SHOP_PRODUCT).replace(':product', this.product.productNumber) },
                                    react_1.default.createElement(Button_1.default, { variant: ButtonVariant_1.default.primary, text: (0, translation_1.t)('software.detail.buy_software') })))) : null))),
                this.product.extensions?.massiveComputedDownload?.key ? (react_1.default.createElement(ScopeGuard_1.default, { scopes: [AuthorizationScopes_1.default.DOWNLOADS_READ] },
                    react_1.default.createElement(SoftwareDownloads_1.default, { software: this.product.extensions.massiveComputedDownload.key, key: this.product.id }))) : null))));
    }
    loadSoftware() {
        if (!ShopwareContext_1.default.customFields?.massiveSoftwareCategory) {
            return;
        }
        this.internalIsLoading = true;
        if (!this.productId) {
            (0, history_1.replaceHistory)(this.props.history, Paths_1.PATH_SOFTWARE);
            return;
        }
        this.product = undefined;
        ShopwareProducts_1.default
            .loadProduct(this.productId, true, true)
            .then((0, mobx_1.action)((product) => (this.product = product)))
            .catch(() => {
            if (!__DEV__) {
                (0, history_1.replaceHistory)(this.props.history, Paths_1.PATH_SOFTWARE);
            }
        })
            .finally((0, mobx_1.action)(() => {
            this.internalIsLoading = false;
        }));
    }
}
exports.default = (0, react_router_dom_1.withRouter)((0, mobx_react_1.observer)(SoftwareDetailPage));
